import * as React from "react";
import { useTranslation } from "src/hooks";
import { Text } from "src/components";
import { observer } from "mobx-react-lite";

export const FilePickerOnDrag = observer(() => {
  const translate = useTranslation();
  return (
    <Text fontWeight="book" fontSize="medium">
      {translate("drop_zone")}
    </Text>
  );
});
